<template>
    <el-dialog custom-class="dialogForm" class="measDialog" :visible.sync="visible" :before-close="handleClose" :close-on-click-modal="false" width="80%" :title="title">
        <el-scrollbar class="dialogContentScroll">
            <el-form :model="form" ref="form" :rules="rules">
                <el-form-item label="校区名称" prop="name">
                    <el-input v-model="form.name" maxlength="20" show-word-limit placeholder="请输入" clearable></el-input>
                </el-form-item>
                <el-form-item label="所在地区" prop="districtcode">
                    <el-cascader v-model="cityCode" :options="cityData" @change="chooseCity" clearable></el-cascader>
                </el-form-item>
                <el-form-item label="具体地址" prop="address">
                    <el-input v-model="form.address" maxlength="200" show-word-limit placeholder="请输入" clearable></el-input>
                </el-form-item>
                <el-form-item label="说明" prop="summary">
                    <el-input v-model="form.summary" type="textarea" show-word-limit autosize maxlength="1000" placeholder="请输入"></el-input>
                </el-form-item>
            </el-form>
        </el-scrollbar>
        <div slot="footer" style="text-align:right">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" :loading="isLoading" @click="saveCampus">确定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import cityData from '@/assets/measAssets/json/citys.json'
import { saveCampus, getCampusDetails } from '@/api/measApi/campusManage.js'
export default {
  data() {
    return {
      visible: false,
      title: '新增校区',
      form: {
        address: '', // 具体地址
        citycode: '', // 地区市code
        cityname: '', // 地区市name
        code: '',
        districtcode: '', // 地区区code
        districtname: '', // 地区区name
        name: '', // 校区名称
        provincecname: '', // 地区省name
        provincecode: '', // 地区省code
        summary: '' // 说明
      },
      rules: {
        name: [{ required: true, message: '请输入校区名称', trigger: 'blur' }],
        districtcode: [
          { required: true, message: '请选择所在地区', trigger: 'change' }
        ],
        address: [
          { required: true, message: '请输入具体地址', trigger: 'blur' }
        ]
      },
      cityData,
      cityCode: [],
      orgForm: {},
      isLoading: false
    }
  },
  methods: {
    handleOpen(code) {
      this.visible = true
      this.orgForm = JSON.parse(JSON.stringify(this.form))
      if (code) {
        this.title = '编辑校区'
        getCampusDetails({ code: code }).then(res => {
          if (res.code === '000') {
            this.form = res.data
            this.cityCode = [
              this.form.provincecode,
              this.form.citycode,
              this.form.districtcode
            ]
          }
        })
      } else {
        this.title = '新增校区'
      }
    },
    chooseCity(value) {
      if (value && value.length > 0) {
        this.form.provincecode = value[0]
        this.form.citycode = value[1]
        this.form.districtcode = value[2]
        this.cityData.map(item => {
          if (item.value === value[0]) {
            this.form.provincecname = item.label
            item.children.map(child => {
              if (child.value === value[1]) {
                this.form.cityname = child.label
                child.children.map(e => {
                  if (e.value === value[2]) {
                    this.form.districtname = e.label
                  }
                })
              }
            })
          }
        })
      } else {
        this.form.provincecode = ''
        this.form.provincecname = ''
        this.form.citycode = ''
        this.form.cityname = ''
        this.form.districtcode = ''
        this.form.districtname = ''
      }
    },
    saveCampus() {
      this.$refs.form.validate(validate => {
        if (validate) {
          this.isLoading = true
          saveCampus(this.form).then(res => {
            if (res.code === '000') {
              this.$message.success(res.msg)
              this.$emit('saveSuccess')
              this.isLoading = false
              this.handleClose()
            }
          })
        }
      })
    },
    handleClose() {
      if (this.isLoading) {
        this.$message.warning('提交数据中，请稍等')
        return
      }
      this.visible = false
      this.form = this.orgForm
      this.cityCode = []
      this.$refs.form.clearValidate()
    }
  }
}
</script>
<style lang="scss" scoped>
</style>

